import { useSyncExternalStore } from 'react';

import { getInstallSnapshot, subscribeToInstallOffer, type InstallMethod } from './installStore.ts';

/**
 * How, if at all, to offer the home screen unasked. Null once it has been turned down.
 *
 * Its own file rather than a member of the component's: a module that exports a component
 * must export nothing else, or Fast Refresh quietly stops working.
 */
export function useInstallOffer(): InstallMethod | null {
  return useSyncExternalStore(subscribeToInstallOffer, getInstallSnapshot).offer;
}

/**
 * How, if at all, the app can be put on the home screen from here — ignoring whether the
 * banner was ever shown or turned down. For the control somebody goes looking for.
 */
export function useInstallCapability(): InstallMethod | null {
  return useSyncExternalStore(subscribeToInstallOffer, getInstallSnapshot).capability;
}
